import { module } from 'modujs';
import { Swiper, Navigation, Parallax } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation, Parallax]);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]

        const args = {
            speed: 1100,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            loopedSlides: 2,
            parallax: true,
            spaceBetween: 0,
            threshold: 3,
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            }
        }

        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if(this.length > 1){
            this.carousel = new Swiper(this.container, args)
            this.arrowPrev.classList.remove('is-hidden')
            this.arrowNext.classList.remove('is-hidden')
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
